import { cn } from '@tempo-io/sui-class-utils';
import { Tooltip, TooltipContent, TooltipTrigger } from '@tempo-io/sui-tooltip';
import type { ReactNode } from 'react';

interface TooltipIconButtonProps {
  icon: ReactNode;
  tooltipText: string;
  onClick?: () => void;
  className?: string;
  side?: 'left' | 'right' | 'top' | 'bottom';
  disabled?: boolean;
}

export const TooltipIconButton = ({
  icon,
  tooltipText,
  onClick,
  className,
  side = 'left',
  disabled = false,
}: TooltipIconButtonProps) => (
  <Tooltip>
    <TooltipTrigger asChild>
      <button
        data-testid={`button-${tooltipText}`}
        type="button"
        className={cn('inline-flex', disabled && 'cursor-not-allowed opacity-60', className)}
        onClick={disabled ? undefined : onClick}
        aria-disabled={disabled}
        disabled={disabled}
      >
        {icon}
      </button>
    </TooltipTrigger>
    <TooltipContent side={side}>
      <p>{tooltipText}</p>
    </TooltipContent>
  </Tooltip>
);
